import { Component } from '@angular/core';

@Component({
  selector: 'app-eiffage-login',
  standalone: true,
  template: '',
})
export class EiffageLoginComponent {}
